import { BASE_ENDPOINT } from "../../../endpoint";

export const printCustomerAccountStatementService = async (
	token: string,
	accountNumber: string,
	filters: { [key: string]: string },
	signal?: any
) => {
	const queryParams = new URLSearchParams(filters).toString();
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/user/customerservice/accountstatement/${accountNumber}/print?${queryParams}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
				signal: signal,
			}
		);
		const res = await response.json();
		if (!response.ok) {
			console.error("Error:", res);
			throw new Error(res.message);
		}
		return res.data;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
